// extracted by mini-css-extract-plugin
module.exports = {"clickable":"Loader_clickable__3xGia","container":"Loader_container__25fpM"};